import {
    SHOW_MODAL,
    HIDE_MODAL
} from "../actions/types";

const INITIAL_STATE = {
    isOpen: false,
    size: 'tiny',
    title: '',
    body: '',
    cancelText: null,
    okText: 'Ok',
    cancelAction: null,
    okAction: null,
    isLoading: false,
    cancelable: false,
    isSuccess: false,
    isError: false,
    duration: 500
}
export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SHOW_MODAL:
            return {
                ...state,
                isOpen: true,
                ...action.payload
            };
        case HIDE_MODAL:
            return INITIAL_STATE // important! here we reset actions
        default:
            return state
    }
}
